import {Module} from 'vuex'
import {state} from './state'
import {ISubscriptionStateModel, IRootStateModel} from './../../interfaces'
import { mutations } from './mutations'
import { getters } from './getters'
import { actions } from './actions'

const subscription: Module<ISubscriptionStateModel, IRootStateModel> = {
    state,
    mutations,
    getters,
    actions
}

export default subscription;